// Image constants for easy access throughout the app
import Cookies from "js-cookie"
// Public root SVG icons
export const ICONS = {
  globe: '/globe.svg',
  next: '/next.svg',
  vercel: '/vercel.svg',
  window: '/window.svg',
  file: '/file.svg',
  redline: '/assets/icons/redline.svg',
  redline2: '/assets/icons/redline2.svg',
  google: '/assets/icons/google.svg',
  apple: '/assets/icons/apple.svg',
  facebook: '/assets/icons/facebook.svg',
  greenTick: '/assets/icons/green_tick.svg',
  verify: '/assets/icons/verify.svg',
  mainlogo: '/assets/icons/mainlogo.svg',
  edit: '/assets/icons/profile/edit.svg',
  delete: '/assets/icons/delete.svg',
  calendar: '/assets/icons/calendar.svg',
  leftArrow: '/assets/icons/left-arrow.svg',
  car: '/assets/icons/car.svg',
  adult: '/assets/icons/adult.svg',
  student: '/assets/icons/student.svg',
  save: '/assets/icons/save.svg',
  excal: '/assets/icons/excal.svg',
  info: '/assets/icons/info.svg',
  person: '/assets/icons/person.svg',
  cancellation: '/assets/icons/cancellation.svg',
  studenthat: '/assets/icons/studenthat.svg',
  child: '/assets/icons/child.svg',
  vodo: '/assets/icons/vodo.svg',
  instagram: '/assets/icons/instagram.svg',
  x: '/assets/icons/x.svg',
  facebookfooter: '/assets/icons/facebookfooter.svg',
  phone: '/assets/icons/phone.svg',
  email: '/assets/icons/email.svg',
  email2: '/assets/icons/email2.svg',
  location: '/assets/icons/location.svg',
  facebookSocial: '/assets/icons/facebookSocial.svg',
  twitterSocial: '/assets/icons/twitterSocial.svg',
  downarrow: '/assets/icons/downarrow.svg',
  drag: '/assets/icons/drag.svg',
  twosidearrow: '/assets/icons/twosidearrow.svg',
  singlearrow: '/assets/icons/single-arrow.svg',
  trash: '/assets/icons/trash.svg',
  faqedit: '/assets/icons/faqedit.svg',
  close: '/assets/icons/close.svg',
  cloud: '/assets/icons/weather/cloud.svg',
  wave: '/assets/icons/weather/wave.svg',
  wind: '/assets/icons/weather/wind.svg',
  visibility: '/assets/icons/weather/visibility.svg',
  flowcar: '/assets/icons/flow/flowcar.svg',
  ship: '/assets/icons/flow/ship.svg',
  booking: '/assets/icons/flow/booking.svg',
  bar: '/assets/icons/flow/bar.svg',
  arrows: '/assets/icons/arrows.svg',
  passenger: '/assets/icons/passenger.svg',
  vehicle: '/assets/icons/vehicle.svg',
  tripcalendar: '/assets/icons/tripcalendar.svg',
  vcalendar: '/assets/icons/vcalendar.svg',
  uparrow: '/assets/icons/uparrow.svg',
  tick: '/assets/icons/tick.svg',
  rightArrow: '/assets/icons/rightArrow.svg',
  leftArrowv: '/assets/icons/leftArrow.svg',
  clock: '/assets/icons/clock.svg',
  to: '/assets/icons/to.svg',
  ferryIcon: '/assets/icons/ferryIcon.svg',
  teerRight: '/assets/icons/teer-right.svg',
  terms: '/assets/icons/terms.svg',
  calendarbook: '/assets/icons/calendarbook.svg',
  confirmed: '/assets/icons/confirmed.svg',
  manualconfirmed: '/assets/icons/manualConfirmed.svg',
  qr: '/assets/icons/qr.svg',
  download: '/assets/icons/download.svg',
  print: '/assets/icons/print.svg',
  warn: '/assets/icons/warn.svg',
  verifyIcon: '/assets/icons/verifyIcon.svg',
  cash: '/assets/icons/cash.svg',
  card: '/assets/icons/card.svg',
  weatherCloud: '/assets/icons/cloud.svg',
  eyeIcon: '/assets/icons/EyeIcon.svg',
  sustain: '/assets/icons/sustain.svg',
  heart: '/assets/icons/heart.svg',
  safetyFirst: '/assets/icons/safetyFirst.svg',
  vid: '/assets/vid.mp4',
  hamburger: '/assets/icons/hamburger.svg',
  addPerson: '/assets/icons/addPerson.svg',
  edituser: '/assets/icons/edituser.svg',
  bell: '/assets/icons/bell.svg',
  passengers: '/assets/icons/passengers.svg',
  carFront: '/assets/icons/car-front.svg',
  adminPrint: '/assets/icons/admin/print.svg',
  transaction: '/assets/icons/admin/reports/transaction.svg',
  passsengerdemo: '/assets/icons/admin/reports/passsengerdemo.svg',
  bd: '/assets/icons/admin/reports/bd.svg',
  revenue: '/assets/icons/admin/reports/revenue.svg',
  adminDownlaod: '/assets/icons/admin/download.svg',
  highWinds: '/assets/icons/delay/high-winds.svg',
  highWave: '/assets/icons/delay/high-wave.svg',
  heavyRain: '/assets/icons/delay/heavy-rain.svg',
  poorVisibility: '/assets/icons/delay/poor-visibility.svg',
  //vehile-height standard
  sh1: '/assets/icons/standard-height/sh1.svg',
  sh2: '/assets/icons/standard-height/sh2.svg',
  sh3: '/assets/icons/standard-height/sh3.svg',
  sh4: '/assets/icons/standard-height/sh4.svg',

  //vehile-height standard
  sl1: '/assets/icons/standard-length/sl1.svg',
  sl2: '/assets/icons/standard-length/sl2.svg',
  sl3: '/assets/icons/standard-length/sl3.svg',
  sl4: '/assets/icons/standard-length/sl4.svg',

  //vehile-height standard
  fs1: '/assets/icons/fullsize-heigth/fs1.svg',
  fs2: '/assets/icons/fullsize-heigth/fs2.svg',
  fs3: '/assets/icons/fullsize-heigth/fs3.svg',
  fs4: '/assets/icons/fullsize-heigth/fs4.svg',

  //vehile-height standard
  fl1: '/assets/icons/fullsize-length/fl1.svg',
  fl2: '/assets/icons/fullsize-length/fl2.svg',
  fl3: '/assets/icons/fullsize-length/fl3.svg',
} as const;

// Assets images
export const IMAGES = {
  login: '/assets/images/login.png',
  signin: '/assets/images/signin.png',
  account: '/assets/images/account.png',
  contact: '/assets/images/contactImage.png',
  ferry: '/assets/images/ferry.png',
  weather: '/assets/images/weather.png',
  history: '/assets/images/history.png',
  re1: '/assets/images/re1.png',
  re2: '/assets/images/re2.png',
  re3: '/assets/images/re3.png',
  re4: '/assets/images/re4.png',
  testimonial: '/assets/images/testimonial.png',
  distort: '/assets/images/distort.png',
  le1: '/assets/images/le1.png',
  le2: '/assets/images/le2.png',
  heightS: '/assets/images/height-s.png',
  heightf: '/assets/images/height-f.png',
  lengthS: '/assets/images/length-s.png',
  lengthf: '/assets/images/length-f.png',
  story: '/assets/images/story.png',
  wave: '/assets/images/wave.png',
  ourHistory: '/assets/images/ourhistory.png',
  h1: '/assets/images/h1.png',
  h2: '/assets/images/h2.png',
  profile: '/assets/images/profile.png',
  story2: '/assets/images/story2.png',
  div: '/assets/images/div.png',
  home: '/assets/images/home-banner.png',

} as const;



export function getAuthHeader() {
  const accessToken = Cookies.get('accessToken')
  if (!accessToken) throw new Error('No access token found')
  return { Authorization: `Bearer ${accessToken}` }
}

// Modal modes enum
export enum ModalMode {
  ADD = 'add',
  EDIT = 'edit'
}

export const countries = [
  { code: "+1", countryCode: "CA", name: "Canada" },
  { code: "+1", countryCode: "US", name: "United States" },
  { code: "+52", countryCode: "MX", name: "Mexico" },
  { code: "+92", countryCode: "PK", name: "Pakistan" },
];